import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

const selectDomain = (state) => state.reviewReport || initialState;

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectIsReviewReportPageLoading = createSelector(
  [selectDomain],
  (state) => state.isReviewReportPageLoading
);
export const selectData = createSelector(
  [selectDomain],
  (state) => state.reportData
);

export const selectMismatchedData = createSelector(
  [selectDomain],
  (state) => state.mismatched
);
export const selectReportUrl = createSelector(
  [selectDomain],
  (state) => state.reportUrl
);
